window.lazySizesConfig = window.lazySizesConfig || {};
window.lazySizesConfig.expand = 360;
window.lazySizesConfig.expFactor = 1;

$(window).load(function() {
	//Load cart so we can check for holds....see theme.js.liquid - checkForHolds()
    ajaxCart.loadInitial();
  	
});

var scrollWindow = function(offset) {
  window.scrollTo({top: offset, behavior: 'smooth'});
}

$(document).ready(function() {
  	//Get path of current page
  	var fullPath = location.pathname + location.search + location.hash;
  	
    // ================ DETECT IF MOBILE ================ //
     var isMobile = false; //initiate as false
     var isTablet = false;
  	 var isDesktop = false;
     // device detection
     if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent) 
         || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0,4))) { 
         isMobile = true;
         if( screen.width > 480 ) { 
             isTablet = true;
        }
     } else {
     	isDesktop = true;
     }
   
	// ================ PREVENT SCROLLING WHEN THERE IS AN OVERLAY ================ //
	var preventScroll = function(bubble) {
		$("html").addClass("qv-is-open");
    }
    var allowScroll = function(bubble) {
		$("html").removeClass("qv-is-open");
    }

	// ================ BLUR BACKGROUND ON OVERLAYS ================ //
	var blurBG = function (){
      $(".modal-overlay").css("backdrop-filter", "blur(30px)")
      	//$(".blur-on-modal-open").css("filter","blur(30px)");	
      	//$(".blur-on-modal-open-header").css("filter","blur(200px)");
     }
    
    var unblurBG = function (){
      	//$(".blur-on-modal-open").css("filter","unset");
       	//$(".blur-on-modal-open-header").css("filter","unset");
    }
    
	// ================ SCROLL TO TOP ================ //
    $("#scroll-to-top").click(function() {
      	//$("html, body").animate({ scrollTop: 0 }, "slow");
      	scrollWindow(0);
      	ga('send', 'event', 'Navigation', 'Scroll to Top', 'Click');
      	return false;
    });
    
      $("#nav-drawer-open").click(function() {
        //$("#navigation-drawer").css("width","250px");
        $("#navigation-drawer").addClass("navigation-drawer-open");
        $(".navigation-drawer-overlay").show();
        $("html").addClass("qv-is-open");
    });
  
  	// ================ SCROLL TO CATEGORY ON SPACE ================ //
  	$(".department-shop-by").click(function(){
     	ga('send', 'event', 'Navigation', 'Shop by Category', 'Click');

      	$('html, body').animate({
            scrollTop: $("#sub-navigation").offset().top
        }, 1500);

    });
	
  	// ================ NAVIGATION DRAWER ================ //
    $("#nav-drawer-close").click(function() {
       	 closeNavDrawer();
    });
  	
	$(".navigation-drawer-overlay").click(function() {
       	 closeNavDrawer();
    });

    // ================ MONITOR SCROLLING ================= //
    $(window).scroll(function (event) {

		//SCROLL DEPTH on Main Feed
        var docHeight = $(document).height(),
        windowHeight = $(window).height(),
        scrollPercent = $(window).scrollTop() / (docHeight - windowHeight) * 100;
        
      	if (fullPath == '/') {
      		sendScrollDepthEvent(scrollPercent);
        }
      
        // RESULT LIST FILTERS
        var scrollTopVal = $(this).scrollTop();
        if (scrollTopVal > 105) {
            if ($("#bubble-header").hasClass("sticky-header-hidden")) {
                $("#rl-filters").addClass('rl-filters-fixed').removeClass("rl-filters-fixed-with-header");
                $("#rl-flex").css("padding-top","65px");
            } else {
                $("#rl-filters").addClass('rl-filters-fixed-with-header').removeClass("rl-filters-fixed");
                $("#rl-flex").css("padding-top","65px");
            }
        } else {
            $("#rl-filters").removeClass('rl-filters-fixed-with');
            $("#rl-filters").removeClass('rl-filters-fixed-with-header');
            $("#rl-flex").css("padding-top","unset");
        }
      	
      	//Fade in Scroll to top
      	if (scrollTopVal > 600) {
         	$("#scroll-to-top").fadeIn(); 
        } else {
        	$("#scroll-to-top").fadeOut();
        }
      
    });
  	
	// =========== FILTER MENU INTERACTIONS =========== //
    $(".rl-filter-item").on("click", function(){
      openFilterMenu(this);
    });

    $("#rl-sort").on("click", function(){
      openFilterMenu(this);
    });


    $(".overlay-back").on("click", function(){
        console.log("yooo");
        closeFilterMenu();
    });

  
  	// =========== STICKY HEADER ===========//
    (function(){

        var doc = document.documentElement;
        var w = window;

        var prevScroll = w.scrollY || doc.scrollTop;
        var curScroll;
        var direction = 0;
        var prevDirection = 0;

        var checkScroll = function() {
          /* Find the direction of scroll: 0 - initial, 1 - up, 2 - down */
          curScroll = w.scrollY || doc.scrollTop;
          if (curScroll > prevScroll) { 
            //scrolled up
            direction = 2;
          } else if (curScroll < prevScroll) { 
            //scrolled down
            direction = 1;
          }
          

          if (direction !== prevDirection) {
            toggleHeader(direction, curScroll);
          }

          prevScroll = curScroll;
        };

        var toggleHeader = function(direction, curScroll) {
            if (direction === 2 && curScroll > 55) { 
              $("#bubble-header").addClass("sticky-header-hidden");
              prevDirection = direction;
            }
            else if (direction === 1) {
              $("#bubble-header").removeClass("sticky-header-hidden");
              prevDirection = direction;
            }
        };
		
      	if (isMobile || isTablet ) {
        	  window.addEventListener('scroll', checkScroll);
        }

	})();
  	
	// =========== SCROLL DEPTH =========== //
  	var scrollDepth25 = false;
  	var scrollDepth50 = false;
  	var scrollDepth75 = false;
  	var scrollDepth100 = false;
  
  	var sendScrollDepthEvent = function(percent) {
        if (percent > 25){if (!scrollDepth25){ga('send', 'event', 'ScrollDistance', 'Percentage', '25%');scrollDepth25 = true;}} 
      	if (percent > 50){if (!scrollDepth50){ga('send', 'event', 'ScrollDistance', 'Percentage', '50%');scrollDepth50 = true;}}
      	if (percent > 75){if (!scrollDepth75){ga('send', 'event', 'ScrollDistance', 'Percentage', '75%');scrollDepth75 = true;}}
      	if (percent > 99){ if (!scrollDepth100){ga('send', 'event', 'ScrollDistance', 'Percentage', '100%');scrollDepth100 = true;}}
    }  	
    
   	// =========== Open Cart or Scanner coming from RM.com =========== //
//   	var openThis = "";
  
//   	var getUrlParameter = function getUrlParameter(sParam) {
//         var sPageURL = window.location.search.substring(1),
//             sURLVariables = sPageURL.split('&'),
//             sParameterName,
//             i;

//         for (i = 0; i < sURLVariables.length; i++) {
//             sParameterName = sURLVariables[i].split('=');

//             if (sParameterName[0] === sParam) {
//                 return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
//             }
//         }
//     };
  
//   	openThis = getUrlParameter('show');
  
//     if (openThis == "cart") {
//       	setTimeout(function(){
//       		$('.js-drawer-open-button-right').trigger('click');
//       	}, 500);
//     } else if (openThis == "scan" ){
// 		openScanner();
//   	}
  
	// =========== CLICK & DRAG SCROLL ON DESKTOP =========== //
    if (!isMobile && !isTablet) {
		if ($(".single-option-radio").length) {
      		$(".single-option-radio").attachDragger();
        }
    }
  
  
});

//click and drag scrolling on desktop
$.fn.attachDragger = function() {
    var attachment = false, lastPosition, position, difference;
    $( $(this).selector ).on("mousedown mouseup mousemove",function(e){
        if( e.type == "mousedown" ) attachment = true, lastPosition = [e.clientX, e.clientY];
        if( e.type == "mouseup" ) attachment = false;
        if( e.type == "mousemove" && attachment == true ){
            position = [e.clientX, e.clientY];
            difference = [ (position[0]-lastPosition[0]), (position[1]-lastPosition[1]) ];
            $(this).scrollLeft( $(this).scrollLeft() - difference[0] );
            $(this).scrollTop( $(this).scrollTop() - difference[1] );
            lastPosition = [e.clientX, e.clientY];
        }
    });
    $(window).on("mouseup", function(){
        attachment = false;
    });
}

// var checkForFind = function(productHandle,shopifyCustomerId,qvLocation) {
//     var returnFindId = 0;

//     var api_url = "https:\/\/rm-cust-api.azurewebsites.net";
//     var api_key = "62ef5543862380993944c863bfe7c1cc";
//     var api_store = "omaha";

//     $(".qv-member-finds .member-finds-add").addClass("member-finds-add_"+productHandle).hide();
//     $(".qv-member-finds .member-finds-remove").addClass("member-finds-remove_"+productHandle).hide();

//     $.ajax({
//         type: "GET",
//         url: api_url+"/v1/memberFinds?coinId="+productHandle+"&shopifyCustomerId="+shopifyCustomerId+"&store="+api_store+"&sortBy=dateCreated:DESC",
//         dataType: 'JSON',
//         headers: {
//           "X-APP-ID":api_key
//         },
//         success: function(data){
//             if (data['statusCode'] == 200 && data['data']['finds'].length > 0) {
//                 returnFindId = data['data']['finds'][0].id;
//                 $(".member-finds-add_"+productHandle).hide();
//                 $(".member-finds-remove_"+productHandle).attr("onclick","removeFind('"+returnFindId+"','"+shopifyCustomerId+"','"+productHandle+"','"+qvLocation+"')").show();

//             } else {
//                 $(".member-finds-remove_"+productHandle).hide();
//                 $(".member-finds-add_"+productHandle).attr("onclick","addToFinds('"+productHandle+"','"+shopifyCustomerId+"','"+qvLocation+"')").show();
//             }
//         },
//         error: function(err) {

//         }
//     });
// }

var addToFinds = function(productHandle,shopifyCustomerId,qvLocation) {
    var api_url = "https:\/\/rm-cust-api.azurewebsites.net";
    var api_key = "62ef5543862380993944c863bfe7c1cc";
    var api_store = "omaha";
    var returnFindId = 0;

    $.ajax({
        type: "POST",
        url: api_url+"/v1/memberFinds?label=General&coinId="+productHandle+"&shopifyCustomerId="+shopifyCustomerId+"&store="+api_store,
        dataType: 'JSON',
        headers: {
          "X-APP-ID":api_key
        },
        success: function(data) {
            returnFindId = data['id'];
            $(".member-finds-add_"+productHandle).hide();
            $(".member-finds-remove_"+productHandle).attr("onclick","removeFind('"+returnFindId+"','"+shopifyCustomerId+"','"+productHandle+"','"+qvLocation+"')").show();

            //update header count
            //$("#member-finds-header-count").html(data['findsCount']);

            //show snackbar
          showSnackBar("Saved to <a href=\"https://rushmarket.com/account/my-boards\">my boards</a>");

            //refresh Member finds page
            refreshMemberFinds(qvLocation);
        },
        error: function(err) {
            refreshMemberFinds(qvLocation);
        }
    });
}

var removeFind = function(findId,shopifyCustomerId,productHandle,qvLocation) {
    var api_url = "https:\/\/rm-cust-api.azurewebsites.net";
    var api_key = "62ef5543862380993944c863bfe7c1cc";
    var api_store = "omaha";

    $.ajax({
        type: "DELETE",
        url: api_url+"/v1/memberFinds/"+findId+"?shopifyCustomerId="+shopifyCustomerId+"&store="+api_store,
        dataType: 'JSON',
        headers: {
          "X-APP-ID":api_key
        },
        success: function(data) {
            $(".member-finds-remove_"+productHandle).hide();
            $(".member-finds-add_"+productHandle).attr("onclick","addToFinds('"+productHandle+"','"+shopifyCustomerId+"','"+qvLocation+"')").show();

            //update header count
            /*
            if (data['findsCount'] > 0 ) {
                $("#member-finds-header-count").html(data['findsCount']);
            } else {
                $("#member-finds-header-count").html("");
            }
            */
            //show snackbar
            showSnackBar("Removed from <a href=\"https://rushmarket.com/account/my-boards\">my boards</a>");

            //refresh Member finds page
            refreshMemberFinds(qvLocation);
        },
        error: function(err) {
            $(".member-finds-add_"+productHandle).hide();
           // $(".remove-find").attr("onclick","removeFind('"+findId+"','"+shopifyCustomerId+"','"+productHandle+"','"+qvLocation+"')").show();
            refreshMemberFinds(qvLocation);
        }
    });
}

var refreshMemberFinds = function(qvLocation) {
    if (qvLocation == 'Member Finds') {
        getMemberFinds();
    }
}

var showSnackBar = function(snackText) {
    var x = document.getElementById("snackbar");
    $(".snackbarText").html(snackText);

    // Add the "show" class to DIV
    x.className = "show";

    // After 5 seconds, remove the show class from DIV
    setTimeout(function(){ closeSnackBar(); }, 5000);
}

var closeSnackBar = function() {
    var x = document.getElementById("snackbar");
    x.className = x.className.replace("show", ""); 
}

var openFilterMenu = function (filter) {
    var filterContent = $(filter).children(".filter-content").html();
    var modalTitle = $(filter).children(".filter-content").attr("title");

    $(".modal-title").html(modalTitle);

    $(".filter-menu-main").html(filterContent);

    $("#filter-menu-overlay").show();

    //blur under overlay
    $(".blur-on-modal-open").css("filter","blur(30px)");
    $(".blur-on-modal-open-header").css("filter","blur(200px)");

    //prevent background scrolling
    $("html").addClass("qv-is-open");
}

var closeFilterMenu = function () {
    $("#filter-menu-overlay").css("display","none");

    //unblur under overlay
    $(".blur-on-modal-open").css("filter","unset");
    $(".blur-on-modal-open-header").css("filter","unset");

    //enable background scrolling
    $("html").removeClass("qv-is-open");
}

var openConditionModal = function() {

    //prevent background scrolling
    $("html").addClass("qv-is-open");

    //blur under overlay
    $(".blur-on-modal-open").css("filter","blur(30px)");
    $(".blur-on-modal-open-header").css("filter","blur(200px)");

    //show qv overlay
    $("#condition-overlay").css("display","block");

}

var closeConditionModal = function() {
    //enable background scrolling
    $("html").removeClass("qv-is-open");

    //hide overlay
    $("#condition-overlay").css("display","none");
    $(".blur-on-modal-open").css("filter","unset");
    $(".blur-on-modal-open-header").css("filter","unset");

}
var closeNavDrawer = function() {
//$("#navigation-drawer").css("width","0px");
    $("#navigation-drawer").removeClass("navigation-drawer-open");
    $(".navigation-drawer-overlay").hide();
    $("html").removeClass("qv-is-open");

}

var showMainNav = function(space) {
    var mainNav = $("#main-menu-content");
    var categoryNav = $("#category_"+space);

    categoryNav.hide();
    mainNav.show();
}

var showCategories = function(space) {
    var mainNav = $("#main-menu-content");
    var categoryNav = $("#category_"+space);

    mainNav.hide();
    categoryNav.show();
}

